import { Section } from '../common/SharedComponents';
import { ShadowCardGrid, ShadowColumns, StyledCardGrid, StyledCardGridWrapper } from './MerchCardSharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BundleTiles = ({
  columns,
  children
}) => {
  return /*#__PURE__*/_jsx(Section, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx("div", {
      className: "flex-column align-center justify-center",
      children: /*#__PURE__*/_jsxs(StyledCardGridWrapper, {
        columns: columns,
        children: [/*#__PURE__*/_jsx(StyledCardGrid, {
          columns: columns,
          children: children
        }), /*#__PURE__*/_jsx(ShadowCardGrid, {
          columns: columns,
          "aria-hidden": "true",
          children: /*#__PURE__*/_jsx(ShadowColumns, {
            columns: columns
          })
        })]
      })
    })
  });
};
export default BundleTiles;